import { IconType, styled, theme } from "../../../../../../styles/stitches.config"
import * as icons from "../../../../../../images/xd/icons"
import { RadioGroupItem, RadioGroupIndicator, Label } from "./ContractSelectionButtons.styled"
import { ReactNode } from "react"
import { Spacer } from "../../../../../../components/spacer/Spacer"

type Props = {
  text: ReactNode
  icon: IconType
  value: string
  selected?: boolean
}

function createIcon(icon: IconType) {
  return styled(icons[icon], {
    flexShrink: 0,
    width: theme.sizes.s12,
    height: theme.sizes.s12,
    "@sm": {
      width: theme.sizes.s16,
      height: theme.sizes.s16,
    },
  })
}

export function ContractSelectionBtn({ text, icon, value, selected }: Props) {
  const Icon = createIcon(icon)

  return (
    <>
      <Label selected={selected}>
        <Icon />
        {text}
        <Spacer size={theme.space.s11} />
        <RadioGroupItem value={value} selected={selected}>
          <RadioGroupIndicator />
        </RadioGroupItem>
      </Label>
    </>
  )
}
